import React, {Component} from 'react';
import styles from './styles.css';

export default class TemplateHelper extends Component {
	render() {
		return (
			<div className={styles['helper']}>
				<div className={styles['helper__wrapper']}>
					{this.props.children}
				</div>
			</div>
		);
	}
}